import { css } from '@emotion/react'

const overlay = css`
  ul > li:not(:last-of-type) {
    margin-bottom: 13px;
  }
`

export const styles = { overlay }
